import { BreadCrumbsWithTitle } from '../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import type { BreadCrumbList } from '../../components/BreadCrumbs/BreadCrumbs.js';
import type { JSX } from 'react';

import './HeroHeading.scss';

export enum HeroHeadingType {
  COMPANY_INFO = 'company-info',
  CUSTOMER_ORDERS = 'customer-orders',
  EMPLOYEE_HOME = 'employee-home',
  EMPLOYEE_ORDERS = 'employee-orders',
  EMPLOYEE_PROFILE = 'employee-profile',
  EMPLOYEE_OMALASKU = 'employee-omalasku',
  INVOICES = 'invoices',
  MESSAGE_CENTER = 'message-center',
  SELFSERVICE_HOME = 'selfservice-home',
  SUBSCRIPTIONS = 'subscriptions',
  BLANK = 'blank',
}

export interface HeroHeadingProps {
  center?: boolean;
  fullScreen?: boolean;
  breadCrumbPaths?: BreadCrumbList;
  extraSection?: JSX.Element;
  heroHeadingType: HeroHeadingType;
  subtitle?: string | JSX.Element;
  smallSubtitle?: boolean;
  title: string;
}

export const HeroHeading = ({
  breadCrumbPaths,
  fullScreen,
  heroHeadingType,
  subtitle,
  title,
  center,
  smallSubtitle,
  extraSection,
}: HeroHeadingProps) => {
  const homePageHero =
    heroHeadingType === HeroHeadingType.EMPLOYEE_HOME || heroHeadingType === HeroHeadingType.SELFSERVICE_HOME;
  const selfServiceHomePageHero = heroHeadingType === HeroHeadingType.SELFSERVICE_HOME;

  return (
    <div
      className={`of-hero-heading ${homePageHero ? 'of-hero-heading__home' : ''}
      ${selfServiceHomePageHero ? 'of-hero-heading__home--self-service' : ''} ${
        fullScreen ? 'of-hero-heading__fullscreen' : ''
      } ${center ? 'of-hero-heading__centered' : ''}`}
    >
      {breadCrumbPaths && breadCrumbPaths.length > 0 && (
        <div className="of-hero-breadcrumbs">
          <BreadCrumbsWithTitle breadCrumbPaths={breadCrumbPaths} />
        </div>
      )}
      <div
        className={`of-hero-heading__wrapper of-hero-heading__image of-hero-heading__image--${heroHeadingType.toString()}`}
      >
        <div className="of-hero-heading__content">
          <h1>{title}</h1>
          <p className={`of-hero-heading__subtitle ${smallSubtitle ? 'ds-text--l' : ''}`}>{subtitle}</p>
          {extraSection}
        </div>
      </div>
    </div>
  );
};
